export enum EQuestionType {
  OPEN_FIELD = "open_field",
  BOOLEAN = "boolean",
  NUMBER = "number",
  FILE = "file",
  DROPDOWN = "dropdown",
  DATE_FIELD = "date_field",
  GROUPED_LIST = "grouped_list",
}
